<template>
  <div class="choose-intercom-source">
    <el-tabs v-model="activeTab">
      <el-tab-pane label="从模板选择"
                   name="1">
        <el-table :data="sourceTemplates"
                  class="table-list">
          <el-table-column label="选择"
                           width="50"
                           align="center">
            <template slot-scope="scope">
              <el-radio v-model="sourceId"
                        :label="scope.row.templateCode">
                <span></span>
              </el-radio>
            </template>
          </el-table-column>
          <el-table-column label="模板名称"
                           prop="templateName"
                           show-overflow-tooltip></el-table-column>
          <el-table-column label="源终端"
                           prop="sourceName"
                           show-overflow-tooltip></el-table-column>
          <el-table-column label="删除"
                           prop="templateCode"
                           width="50"
                           align="center">
            <template slot-scope="scope">
              <el-button type="text"
                         icon="el-icon-delete"
                         @click="deleteTemplate(scope.row.templateCode)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="选择源终端"
                   name="2">
        <el-form ref="sourceForm"
                 :model="sourceForm">
          <el-form-item prop="sourceId"
                        label="源终端"
                        :rules="sourceRules.sourceId">
            <template>
              <div class="source-name-area">
                <div class="source-name"
                     :class="{ 'hidden-item': !sourceForm.sourceId }"
                     :title="sourceForm.sourceName">
                  {{ sourceForm.sourceName }}
                </div>
                <div class="text-right">
                  <el-button type="text"
                             icon="el-icon-plus"
                             @click="chooseSource">
                    选择源终端
                  </el-button>
                </div>
              </div>
            </template>
          </el-form-item>
          <div class="template-area">
            <el-button class="switch-save-button"
                       type="text"
                       @click="toggleSave">
              <template>
                <div>
                  <i class="el-icon-d-arrow-left expand-icon"
                     :class="saveasTemplate ? 'expand' : 'collspan'"></i>
                  <span>{{ saveasTemplate ? "不" : "" }}保存模板</span>
                </div>
              </template>
            </el-button>
            <div class="template-info"
                 :class="{ active: saveasTemplate }">
              <el-form-item prop="templateName"
                            label="模板名称"
                            :rules="sourceRules.templateName"
                            label-width="80px">
                <template>
                  <el-input v-model="sourceForm.templateName"
                            placeholder="请输入模板名称">
                  </el-input>
                </template>
              </el-form-item>
              <div class="save-button">
                <el-button type="primary"
                           @click="saveTemplate">
                  保存为模板
                </el-button>
              </div>
            </div>
          </div>
        </el-form>
      </el-tab-pane>
    </el-tabs>
    <el-dialog class="source-dialog"
               v-dialogDrag
               title="选择源终端"
               :modal-append-to-body="false"
               :visible="sourceDialog"
               width="500px"
               :before-close="closeSourceDialog">
      <div style="height: 300px">
        <el-scrollbar style="height: 100%">
          <el-tree ref="deviceTree"
                   :data="sourceData"
                   highlight-current
                   :default-expanded-keys="expandedKeys"
                   node-key="id"
                   :props="treeProps"></el-tree>
        </el-scrollbar>
      </div>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="confirmSourceDialog">确认</el-button>
        <el-button type="info"
                   @click="closeSourceDialog">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { api } from "../api";
export default {
  components: {},
  model: {
    prop: "intercomSource",
    event: "handleReturn",
  },
  props: {
    intercomSource: {
      type: String,
      default: () => {
        return "";
      },
    },
  },
  watch: {
    intercomSource (newVal) {
      this.sourceId = newVal;
      // this.newSourceId = newVal
    },
    sourceId (newVal) {
      console.log(newVal)
      this.sourceTemplates.forEach(el => {
        if (el.templateCode == newVal) {
          this.newSourceId = el.sourceId
        }
      })
      this.sourceId = newVal;
      this.$emit("handleReturn", this.sourceId);
    },
  },
  data () {
    return {
      sourceId: "",
      activeTab: "1",
      sourceTemplates: [],
      sourceForm: {
        sourceId: "",
        templateName: "",
        sourceName: "",
      },
      newSourceId: "",
      saveasTemplate: false,
      sourceRules: {
        sourceId: [
          {
            required: true,
            message: "请选择源终端",
            trigger: "blur",
          },
        ],
        templateName: [
          {
            required: true,
            message: "请输入模板名称",
            trigger: "blur",
          },
        ],
      },
      sourceData: [],
      treeProps: {
        label: "name",
        children: "subTreeModelList",
      },
      expandedKeys: [],
      sourceDialog: false,
    };
  },
  mounted () {
    this.getTemplates();
    this.getSourceData();
  },
  methods: {
    getSourceData () {
      const params = {
        // 设备子类型 26-广播（包含广播和麦克风），18-摄像机
        deviceMarkList: [26],
        // 是否需要权限过滤，0：不过滤，1：过滤
        authorityFlag: 1,
      };
      this.$fetch(api.queryAreaDeviceTree, params).then((res) => {
        if (res.success) {
          this.sourceData = res.returnObj || [];
          if (this.sourceData && this.sourceData.length) {
            this.expandedKeys = [this.sourceData[0].id];
          }
        } else {
          this.$message.error(res.msgContent || "查询源终端列表失败");
        }
      });
    },
    deleteTemplate (templateCode) {
      this.$confirm("确定删除该源终端模板吗？", "删除源终端模板", {
        type: "warning",
      })
        .then((result) => {
          if (result) {
            this.$fetch(api.deleteRemoteCallTemplate, {
              templateCode: templateCode,
            }).then((res) => {
              if (res.success) {
                this.$message.success("删除源终端模板成功");
                this.getTemplates();
              } else {
                this.$message.error(res.msgContent || "删除源终端模板失败");
              }
            });
          }
        })
        .catch((e) => {
          this.$log.debug("用户取消删除源终端模板");
        });
    },
    getTemplates () {
      this.sourceTemplates = [];
      this.$fetch(api.queryRemoteCallTemplate).then((res) => {
        if (res.success) {
          (res.returnObj || []).forEach((item) => {
            this.sourceTemplates.push({
              templateCode: item.templateCode,
              sourceId: item.sourceTerminalId,
              templateName: item.templateName,
              sourceName: item.sourceTerminalName,
            });
          });
        } else {
          this.$message.error(res.msgContent || "查询源终端模板列表失败");
        }
      });
    },
    chooseSource () {
      this.sourceDialog = true;
    },
    toggleSave () {
      this.saveasTemplate = !this.saveasTemplate;
    },
    saveTemplate () {
      this.$refs.sourceForm.validate((result) => {
        if (result) {
          let params = {
            sourceTerminalId: this.sourceForm.sourceId, //源终端ID
            templateName: this.sourceForm.templateName, // 模板名称
          };
          this.$fetch(api.addRemoteCallTemplate, params).then((res) => {
            if (res.success) {
              this.$message.success("新增源终端模板成功");
              this.getTemplates();
              // 保存成功后，设置页面跳转至模板选择页面
              this.activeTab = "1";
              // 将设置模板的参数设置为空，同时收起保存模板的输入框
              this.$refs.sourceForm.resetFields();
              this.saveasTemplate = false;
            } else {
              this.$message.error(res.msgContent || "新增源终端模板失败");
            }
          });
        }
      });
    },
    confirmSourceDialog () {
      let checkedNode = this.$refs.deviceTree.getCurrentNode();
      if (checkedNode.deviceType !== "26") {
        this.$message.error("当前选择的不是广播设备类型");
        this.$log.info("当前选择的设备不是广播设备");
        return;
      }
      this.sourceId = checkedNode.thirdDeviceId;
      this.sourceForm.sourceId = this.sourceId;
      this.sourceForm.sourceName = checkedNode.name;
      this.closeSourceDialog();
    },
    closeSourceDialog () {
      this.sourceDialog = false;
    },
    clearForm () {
      if (this.$refs.sourceForm) {
        this.$refs.sourceForm.resetFields();
      }
    },
  },
};
</script>

<style lang="scss">
@import "~@src/common/assets/style/mixin";
.choose-intercom-source {
  position: relative;
  width: 100%;

  .hidden-item {
    visibility: hidden;
  }

  .source-name {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .text-right {
    text-align: right;
  }

  .text-center {
    text-align: center;
  }

  .table-list {
    margin-bottom: 10px;
  }

  .switch-save-button {
    margin-bottom: 5px;
  }

  .expand-icon {
    @include set_animation(transform);

    &.expand {
      transform: rotate(90deg);
    }

    &.collspan {
      transform: rotate(-90deg);
    }
  }

  .template-info {
    height: 0;
    overflow: hidden;
    @include set_animation(height);

    &.active {
      height: 100px;
    }
  }

  .save-button {
    margin-top: 10px;
    text-align: center;
  }

  .source-name-area {
    display: flex;
    justify-content: space-between;
  }
}
</style>
